var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NewsDetails"},[_c('NavBar',{attrs:{"navs":_vm.navs}}),_c('Article',{attrs:{"detail":_vm.getDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }